/* ============================================================
   Enclir motion engine
   - [data-reveal]               : fade/rise into view (variants: fade|scale|left|right)
   - [data-reveal-group]         : staggers its [data-reveal] descendants
   - [data-reveal-delay="120"]   : explicit per-element delay in ms (overrides stagger)
   - [data-count="98.5"]         : count up to value when scrolled into view
        data-count-prefix / data-count-suffix : optional affixes
   ============================================================ */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- count-up ---------- */
  function formatCount(raw, val) {
    var decimals = (String(raw).split('.')[1] || '').length;
    return val.toFixed(decimals);
  }
  function finalCount(el) {
    var raw = el.getAttribute('data-count');
    var pre = el.getAttribute('data-count-prefix') || '';
    var suf = el.getAttribute('data-count-suffix') || '';
    el.textContent = pre + raw + suf;
  }
  function animateCount(el) {
    var raw = el.getAttribute('data-count');
    var target = parseFloat(raw);
    if (isNaN(target)) return;
    var pre = el.getAttribute('data-count-prefix') || '';
    var suf = el.getAttribute('data-count-suffix') || '';
    var dur = 1150, start = null;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = pre + formatCount(raw, target * eased) + suf;
      if (p < 1) requestAnimationFrame(step);
      else finalCount(el);
    }
    requestAnimationFrame(step);
  }

  var reveals = [].slice.call(document.querySelectorAll('[data-reveal]'));
  var counts  = [].slice.call(document.querySelectorAll('[data-count]'));

  if (reduce || !('IntersectionObserver' in window)) {
    reveals.forEach(function (el) { el.classList.add('is-in', 'is-done'); });
    counts.forEach(finalCount);
    return;
  }

  /* ---------- assign stagger delays inside groups ---------- */
  [].slice.call(document.querySelectorAll('[data-reveal-group]')).forEach(function (group) {
    var items = [].slice.call(group.querySelectorAll('[data-reveal]'));
    items.forEach(function (it, i) {
      if (!it.hasAttribute('data-reveal-delay') && !it.style.transitionDelay) {
        it.style.transitionDelay = Math.min(i * 75, 450) + 'ms';
      }
    });
  });
  reveals.forEach(function (el) {
    var d = el.getAttribute('data-reveal-delay');
    if (d) el.style.transitionDelay = parseInt(d, 10) + 'ms';
  });

  /* ---------- reveal observer ---------- */
  var revIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      el.classList.add('is-in');
      revIO.unobserve(el);
      // clear transient props after the transition so sticky/layout is unaffected
      window.setTimeout(function () {
        el.style.transitionDelay = '';
        el.classList.add('is-done');
      }, 1000);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -7% 0px' });
  reveals.forEach(function (el) { revIO.observe(el); });

  /* ---------- count observer ---------- */
  var cntIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      animateCount(e.target);
      cntIO.unobserve(e.target);
    });
  }, { threshold: 0.6 });
  counts.forEach(function (el) { cntIO.observe(el); });
})();
